export default __webpack_public_path__ + "static/media/special-cat.1c15e39d.webp";